export default __webpack_public_path__ + "static/media/facebook.0d4cbfa1.svg";